import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const processLogin = async () => {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      
      const error = params.get('error');
      if (error) {
        toast.error(decodeURIComponent(error));
        navigate("/admin/login");
        return;
      }
      
      // Novo fluxo: apenas token na URL
      const token = params.get('token');
      if (token) {
        try {
          localStorage.setItem("token", token);
          
          // Buscar dados do usuário com o token
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          localStorage.setItem("user", JSON.stringify(response.data));
          toast.success("Login realizado com sucesso!");
          
          const user = response.data;
          if (!user.company_id && !user.tenant_id) {
            navigate(user.status === "pending_approval" ? "/onboarding/pending-approval" : "/onboarding/join-company");
          } else {
            navigate("/admin/welcome");
          }
          return;
        } catch (e) {
          // Se /auth/me falhar, tentar salvar o que temos e ir pro welcome
          toast.success("Login realizado!");
          navigate("/admin/welcome");
          return;
        }
      }
      
      // Fallback: dados completos na URL (formato antigo)
      const dataStr = params.get('data');
      if (dataStr) {
        try {
          const data = JSON.parse(decodeURIComponent(dataStr));
          localStorage.setItem("token", data.access_token);
          localStorage.setItem("user", JSON.stringify(data.user));
          toast.success("Login realizado com sucesso!");
          
          const user = data.user;
          if (!user.company_id && !user.tenant_id) {
            navigate(user.status === "pending_approval" ? "/onboarding/pending-approval" : "/onboarding/join-company");
          } else {
            navigate("/admin/welcome");
          }
        } catch (e) {
          toast.error("Erro ao processar login");
          navigate("/admin/login");
        }
        return;
      }
      
      navigate("/admin/login");
    };
    
    processLogin();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-500">{processing ? "Processando login..." : "Redirecionando..."}</p>
    </div>
  );
};

export default AuthCallback;
